import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const QUIET = /^\/(?:carrito|login|my-business|cotizador)(?:\/|$)/i;
const CONTROLS = 'a,button,input,textarea,select,label,form,dialog,[role="button"],[role="dialog"],[contenteditable],img,svg,article,figure,h1,h2,h3,h4,p,span,.banner-item,.product-card';
const CSS = `
.disdel-halloween{position:fixed;inset:0;z-index:1100;pointer-events:none;overflow:hidden;contain:strict}
.disdel-halloween,.disdel-halloween *{pointer-events:none!important;box-sizing:border-box}
.disdel-halloween__web{position:absolute;top:0;width:66px;height:66px;color:#fff;opacity:.45}
.disdel-halloween__web--left{left:0}.disdel-halloween__web--right{right:0;transform:scaleX(-1)}
.disdel-halloween__particle{position:absolute;width:30px;height:30px}
.disdel-halloween__particle svg{display:block;width:100%;height:100%}
.disdel-halloween__pumpkin{animation:disdel-pumpkin-pop 950ms ease-out both}
.disdel-halloween__candy{width:19px;height:19px;animation:disdel-candy-fall 5800ms linear both}
@keyframes disdel-pumpkin-pop{0%{opacity:0;transform:translate(-50%,-40%) scale(.5)}20%{opacity:.9;transform:translate(-50%,-65%) scale(1)}75%{opacity:.85}100%{opacity:0;transform:translate(-50%,-130%) scale(.85)}}
@keyframes disdel-candy-fall{0%{opacity:0;transform:translateY(-30px) rotate(0deg)}10%,85%{opacity:.65}100%{opacity:0;transform:translateY(calc(100vh + 30px)) rotate(110deg)}}
@media(max-width:1024px){.disdel-halloween__web{width:40px;height:40px;opacity:.28}.disdel-halloween__particle{display:none}}
@media(prefers-reduced-motion:reduce){.disdel-halloween__particle{display:none;animation:none}}

/* Octubre ilustrado: escenas estáticas sólo cuando caben en los márgenes. */
.disdel-halloween__web{width:104px;height:104px;opacity:.62;color:#eee4fa}
.disdel-halloween__particle{width:42px;height:42px}
.disdel-halloween__candy{width:24px;height:24px}
.disdel-halloween__scene,.disdel-halloween__night{display:none;position:absolute}
.disdel-halloween__scene{bottom:24px;left:max(14px,calc((100vw - 1400px)/4 - 58px));width:116px;height:126px}
.disdel-halloween__scene svg{display:block;width:100%;height:100%}
.disdel-halloween__pumpkin-big{position:absolute;width:83px;height:83px;left:25px;bottom:19px;transform:rotate(8deg)}
.disdel-halloween__pumpkin-small{position:absolute;width:55px;height:55px;left:2px;bottom:15px;transform:rotate(-12deg)}
.disdel-halloween__scene-shadow{position:absolute;bottom:12px;left:3px;width:108px;height:13px;background:radial-gradient(ellipse,rgba(67,40,85,.16),transparent 70%)}
.disdel-halloween__season{position:absolute;bottom:0;left:16px;font:600 9px/1.2 system-ui,sans-serif;letter-spacing:2.5px;text-transform:uppercase;color:#7d627e}
.disdel-halloween__night{top:142px;right:max(14px,calc((100vw - 1400px)/4 - 50px));width:100px;height:116px}
.disdel-halloween__night svg{width:100%;height:100%;display:block}
.disdel-halloween__spider{display:none;position:absolute;left:31px;top:66px;width:24px;height:62px;opacity:.8}
@media(min-width:1640px){.disdel-halloween__scene,.disdel-halloween__night,.disdel-halloween__spider{display:block}}
@media(min-width:1025px) and (max-width:1639px){.disdel-halloween__web{width:64px;height:64px}}
@media(max-width:1024px){.disdel-halloween__web{width:49px;height:49px;opacity:.4}.disdel-halloween__spider{display:none}}

/* Escenas compactas: abajo a la izquierda, lejos de los widgets derechos. */
@media(min-width:481px) and (max-width:1024px){
 .disdel-halloween__scene{display:block;left:0;bottom:calc(3px + env(safe-area-inset-bottom,0px));transform:scale(.53);transform-origin:left bottom}
 .disdel-halloween__night{display:none}
 .disdel-halloween__web{width:56px;height:56px;opacity:.48}
 .disdel-halloween__particle{display:block;width:30px;height:30px}
 .disdel-halloween__candy{width:14px;height:14px}
}
@media(max-width:480px){
 .disdel-halloween__scene{display:block;left:-5px;bottom:calc(-4px + env(safe-area-inset-bottom,0px));transform:scale(.38);transform-origin:left bottom}
 .disdel-halloween__season{display:none}
 .disdel-halloween__night{display:none}
 .disdel-halloween__web{width:43px;height:43px;opacity:.44}
 .disdel-halloween__particle{display:block;width:27px;height:27px}
 .disdel-halloween__candy{width:12px;height:12px}
}
@media(prefers-reduced-motion:reduce){.disdel-halloween__particle{display:none;animation:none}}

`;

function Web({ side }) {
  return <svg className={`disdel-halloween__web disdel-halloween__web--${side}`} viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth=".8" focusable="false">
    <path d="M0 0H80M0 0V80M0 0L73 30M0 0L57 57M0 0L30 73" />
    <path d="M18 0Q14 6 16.5 7Q12 10 12.7 12.7Q6 14 7 16.5Q0 15 0 18M38 0Q29 11 35 14.5Q25 21 27 27Q14 28 14.5 35Q0 30 0 38M59 0Q45 16 54.5 22.5Q39 32 41.7 41.7Q22 44 22.5 54.5Q0 46 0 59M80 0Q62 21 74 30.6Q52 43 56.6 56.6Q30 59 30.6 74Q0 62 0 80" />
  </svg>;
}
function Pumpkin() {
  return <svg viewBox="0 0 40 40" focusable="false">
    <path d="M20 12Q18 6 24 5" fill="none" stroke="#48713b" strokeWidth="3" strokeLinecap="round" />
    <ellipse cx="13" cy="24" rx="10" ry="12" fill="#e78521" /><ellipse cx="27" cy="24" rx="10" ry="12" fill="#e78521" /><ellipse cx="20" cy="24" rx="9" ry="13" fill="#f5a12b" />
    <path d="M10 22L15 17L18 23ZM23 23L26 17L31 22ZM12 28L17 30L20 28L23 30L29 27Q25 36 19 33Q15 34 12 28" fill="#49374b" />
  </svg>;
}
function Candy({ color }) {
  return <svg viewBox="0 0 40 30" focusable="false"><path d="M12 11L2 5L4 15L2 25L12 19M28 11L38 5L36 15L38 25L28 19" fill={color} /><rect x="10" y="6" width="20" height="18" rx="6" fill={color} /><path d="M17 7L14 23M24 7L21 23" stroke="#fff" strokeOpacity=".65" strokeWidth="3" /></svg>;
}


function OctoberScene() {
  return <>
    <svg className="disdel-halloween__spider" viewBox="0 0 24 62" fill="none" focusable="false">
      <path d="M12 0V42" stroke="#e5d7ef" strokeWidth=".8" />
      <g stroke="#4a315c" strokeWidth="1.4" strokeLinecap="round"><path d="M9 47L4 42L2 47M8 50L2 49L1 54M15 47L20 42L22 47M16 50L22 49L23 54M9 53L5 56L5 60M15 53L19 56L19 60" /></g>
      <ellipse cx="12" cy="50" rx="5" ry="6" fill="#4a315c" /><circle cx="10.5" cy="48.5" r=".9" fill="#ffe8b0" /><circle cx="13.5" cy="48.5" r=".9" fill="#ffe8b0" />
    </svg>
    <div className="disdel-halloween__scene">
      <div className="disdel-halloween__scene-shadow" />
      <div className="disdel-halloween__pumpkin-big"><Pumpkin /></div>
      <div className="disdel-halloween__pumpkin-small"><Pumpkin /></div>
      <svg viewBox="0 0 116 126" focusable="false" style={{ position:'absolute', inset:0 }}>
        <path d="M18 13v8m-4-4h8M99 6v7m-3.5-3.5h7M108 54v6m-3-3h6" stroke="#c29449" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M34 20Q22 12 16 18L20 26Q25 21 29 27L34 23L39 27Q43 21 48 26L52 18Q45 12 34 20" fill="#685077" />
      </svg>
      <div className="disdel-halloween__season">Octubre</div>
    </div>
    <div className="disdel-halloween__night">
      <svg viewBox="0 0 100 116" focusable="false">
        <path d="M69 9A33 33 0 1 0 79 70A31 31 0 0 1 69 9" fill="#f6d699" />
        <path d="M40 37Q25 26 13 32L19 45Q26 38 33 46L40 42L47 46Q54 38 61 45L67 32Q54 26 40 37" fill="#523763" />
        <path d="M70 82Q60 75 54 79L58 87Q64 83 68 89L71 86L75 89Q79 83 85 87L89 79Q81 75 70 82" fill="#7e638d" />
        <path d="M20 63v8m-4-4h8M88 21v6m-3-3h6M44 100v6m-3-3h6" stroke="#ba985e" strokeWidth="1.2" strokeLinecap="round" />
        <circle cx="14" cy="95" r="1.5" fill="#b9a4c4" /><circle cx="89" cy="55" r="1.5" fill="#b9a4c4" />
      </svg>
    </div>
  </>;
}

// Desactivar con enabled={false}. Sólo octubre, sin librerías ni imágenes externas.
export default function HalloweenDecor({ enabled = true }) {
  const { pathname } = useLocation();
  const active = enabled && new Date().getMonth() === 9 && !QUIET.test(pathname);
  const [particles, setParticles] = useState([]);
  useEffect(() => {
    setParticles([]);
    if (!active) return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 1025px)');
    const removals = new Set();
    let nextCandy, sequence = 0, lastClick = 0, disposed = false, firstCandy = true;
    const canAnimate = () => !document.hidden && !reduced.matches;
    const addParticle = (particle, lifetime) => {
      const id = ++sequence;
      setParticles(current => current.length < (desktop.matches ? 6 : document.documentElement.clientWidth > 480 ? 5 : 3) ? [...current, { ...particle, id }] : current);
      const timer = window.setTimeout(() => {
        removals.delete(timer);
        if (!disposed) setParticles(current => current.filter(item => item.id !== id));
      }, lifetime);
      removals.add(timer);
    };
    const scheduleCandy = () => {
      window.clearTimeout(nextCandy);
      if (!canAnimate()) return;
      nextCandy = window.setTimeout(() => {
        if (!canAnimate()) return;
        const width = document.documentElement.clientWidth;
        const phone = width <= 480;
        const contentWidth = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-max-width')) || 1400;
        const gutter = Math.max(0, (width - contentWidth) / 2);
        const count = desktop.matches ? 4 : phone ? 2 : 3;
        const candyWidth = desktop.matches ? 24 : phone ? 12 : 14;
        const colors = ['#e89a35', '#80609a', '#c48b42', '#8ba84a'];
        for (let index = 0; index < count; index += 1) {
          // Alternar lados y escalonar la caída; mantener el centro despejado.
          const edgeSpace = Math.max(0, Math.min(42, gutter - candyWidth - 6));
          const inset = 2 + Math.random() * edgeSpace;
          const x = index % 2 === 0 ? inset : width - inset - candyWidth;
          const delay = index * 650;
          addParticle({ type: 'candy', x, y: -24, color: colors[index % colors.length], delay }, 6000 + delay);
        }
        scheduleCandy();
      }, firstCandy
        ? (firstCandy = false, 4500 + Math.random() * 1500)
        : (desktop.matches ? 12000 : document.documentElement.clientWidth > 480 ? 16000 : 20000) + Math.random() * 6000);
    };
    const showPumpkin = event => {
      if (!canAnimate() || event.button !== 0 || !event.isPrimary) return;
      if (!(event.target instanceof Element) || event.target.closest(CONTROLS)) return;
      if (window.getSelection()?.toString()) return;
      const now = Date.now();
      if (now - lastClick < 900) return;
      lastClick = now;
      addParticle({ type: 'pumpkin', x: event.clientX, y: event.clientY }, 1000);
    };
    // Un gesto de desplazamiento no debe producir una calabaza.
    let touchStart = null;
    const onPointerDown = event => {
      if (event.pointerType === 'touch') {
        touchStart = { x: event.clientX, y: event.clientY, time: Date.now(), id: event.pointerId };
      } else {
        showPumpkin(event);
      }
    };
    const onPointerUp = event => {
      if (event.pointerType !== 'touch' || !touchStart) return;
      const start = touchStart;
      touchStart = null;
      if (event.pointerId === start.id && Date.now() - start.time < 500 &&
          Math.hypot(event.clientX - start.x, event.clientY - start.y) < 9) {
        showPumpkin(event);
      }
    };
    const cancelTouch = () => { touchStart = null; };
    const reset = () => {
      window.clearTimeout(nextCandy);
      removals.forEach(timer => window.clearTimeout(timer));
      removals.clear();
      setParticles([]);
      scheduleCandy();
    };
    document.addEventListener('pointerdown', onPointerDown, { passive: true });
    document.addEventListener('pointerup', onPointerUp, { passive: true });
    document.addEventListener('pointercancel', cancelTouch, { passive: true });
    document.addEventListener('visibilitychange', reset);
    reduced.addEventListener('change', reset);
    desktop.addEventListener('change', reset);
    scheduleCandy();
    return () => {
      disposed = true;
      window.clearTimeout(nextCandy);
      removals.forEach(timer => window.clearTimeout(timer));
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', cancelTouch);
      document.removeEventListener('visibilitychange', reset);
      reduced.removeEventListener('change', reset);
      desktop.removeEventListener('change', reset);
    };
  }, [active, pathname]);
  if (!active) return null;
  return <div className="disdel-halloween" aria-hidden="true">
    <style>{CSS}</style><Web side="left" /><Web side="right" /><OctoberScene />
    {particles.map(p => <div key={p.id} className={`disdel-halloween__particle disdel-halloween__${p.type}`} style={{ left: p.x, top: p.y, animationDelay: `${p.delay || 0}ms` }}>{p.type === 'pumpkin' ? <Pumpkin /> : <Candy color={p.color} />}</div>)}
  </div>;
}
